<template>
  <div class="loading-spinner">
    <div class='demo'>
      <div class='circle'>
        <div class='inner'></div>
      </div>
      <div class='circle'>
        <div class='inner'></div>
      </div>
      <div class='circle'>
        <div class='inner'></div>
      </div>
      <div class='circle'>
        <div class='inner'></div>
      </div>
      <div class='circle'>
        <div class='inner'></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingSpinner'
}
</script>
<style lang="scss" scoped>
.demo {
  width: 80px;
  height: 82px;
  border-radius: 100%;
  // position: absolute;
  // top: 45%;
  // left: calc(50% - 50px);
}

.circle {
  width: 100%;
  height: 100%;
  position: absolute;
}

.inner {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 2px solid rgba(255, 201, 196, 0.5);
  border-right: 0;
  border-top: 0;
  background-clip: padding;
  box-shadow: inset 0 0 15px rgba(255, 201, 196, 0.15);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.circle:nth-of-type(0) {
  transform: rotate(0deg);
}

.circle:nth-of-type(0) .inner {
  animation: spin 2s infinite linear;
}

.circle:nth-of-type(1) {
  transform: rotate(70deg);
}

.circle:nth-of-type(1) .inner {
  animation: spin 2s infinite linear;
}

.demo {
  animation: spin 2s infinite linear;
}

</style>
